export default "__VITE_ASSET__64d4c7f2__"